import { FC } from "react";
import { IPreview } from "@components/projects/level01/level01.state";
import styles from "./preview.module.scss";
import animations from "../../animations/animations.module.scss";
import Image from "next/image";
import Level01Animation from '@components/projects/level01/animations';

interface PreviewSectionProps {
  section: IPreview;
}

const PreviewSection: FC<PreviewSectionProps> = ({ section }) => {
  return (
    <Level01Animation render={(ref) => (
      <section ref={ref} className={`${styles.section} ${animations.scroll__animation}`}>
        <div className={styles.section__head}>
          <h1 className={styles.section__title}>{section.title}</h1>
          <p className={styles.section__subtitle}>{section.subtitle}</p>
        </div>
        <div className={styles.section__image}>
          <Image src={section.imageUrl} alt={section.title} layout={"fill"} />
        </div>
        <div className={styles.section__content}>
          {section.content.map((paragraph, idx) => (
            <p key={idx} className={styles.section__content_item}>
              {paragraph}
            </p>
          ))}
        </div>
      </section>
    )}/>
  );
};

export default PreviewSection;
